import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";

export const fileApi = {
    upload: (files: any) => {
        return new Promise<CreDtos.UploadTemporaryFileResponse>((resolve, reject) => {
            var client = new JsonServiceClient("");
            var parameters = new CreDtos.UploadTemporaryFile();
            const formData = new FormData();
            formData.append('files[]', files[0], files[0].name);
            client.postBody(parameters, formData).then(r => {
                resolve(r);
            }).catch(x => {
                reject(x)
            });
        });

    }
};


// WEBPACK FOOTER //
// ./src/services/file.service.ts